import React from 'react';
import NMLogo from 'src/assets/images/naturemetrics_logo.png';

export type DownloadImageLogoProps = {
    containerClass?: string;
    textClass?: string;
};

const DownloadImageLogo = (props: DownloadImageLogoProps) => {
    const { containerClass, textClass } = props;
    return (
        <div className={containerClass} id='data-map-logo-section'>
            <span className={textClass || 'absolute top-2 right-4 text-[17px] text-grey-80'}>Powered by</span>
            <img src={NMLogo} alt='Nature Metrics' className='w-[184px] h-[82px]' />
        </div>
    );
};

export default DownloadImageLogo;
